import { connect } from 'react-redux';
import InstitutionDetails from './InstitutionDetails';

const mapStateToProps = (state) => ({
  institution: state.institution,
});

export default connect(mapStateToProps)(InstitutionDetails);
